import ProjectGridSection from "../../../components/common/ProjectGridSection"
import { TProjectSelection } from "../../../types/index"

type ProjectSelectionSectionProps = Pick<TProjectSelection, "heading" | "projects">

export default function ProjectSelectionSection({ heading, projects }: ProjectSelectionSectionProps) {
    const mappedProjects = (projects?.data ?? []).flatMap((project) => {
        const source = project.attributes.preview ?? project.attributes

        if (!source.label || !source.sublabel) {
            return []
        }

        return [
            {
                id: project.id,
                label: source.label,
                sublabel: source.sublabel,
                alignmentClass: source.alignmentClass,
                width: source.width,
                quote: source.quote,
                url: source.url,
                previewImage: project.attributes.previewImage,
                screenshot: project.attributes.screenshot ?? source.screenshot,
                hasDetailPage: project.attributes.hasDetailPage ?? source.hasDetailPage ?? false,
            },
        ]
    })

    return (
        <ProjectGridSection
            className="max-w-[1500px]"
            heading={heading}
            projects={mappedProjects}
        />
    )
}
